import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { SocialsComponent } from './socials.component';

@NgModule({
  imports: [
    RouterModule.forChild([
      { path:'SocialsModule', loadChildren: () => import('./socials.module').then(m => m.SocialsModule)},
      { path: '', component: SocialsComponent }
    ])
  ],
  exports: [RouterModule]
})
export class SocialsRoutingModule { }
